export default function Headings({
  headingContent,
  headingClassName,
  rte = false
}) {
  if (rte === false) {
    return <h2 className={`${headingClassName}`}>{headingContent}</h2>;
  } else {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: headingContent }}
        className={`${headingClassName} `}
      />
    );
  }
}
